<template>
  <div class="blockwrapper" :class="{ open: open }">
    <div
      class="top"
      :style="{ background: item.color }"
      @click="toggle"
      :class="{ disabled: disabled }"
    >
      <span v-if="disabled && isStaff" class="parentOnlyLabel"
        >Parent Only</span
      >
      <span v-if="disabled && !isStaff" class="parentOnlyLabel"
        >Staff Only</span
      >
      <span style="max-width: 170px">{{ item.category }}</span>
      <img
        src="@/assets/up-arrow.png"
        alt=""
        class="chevron"
        :class="{ active: open, grey: disabled }"
      />
      <div class="gradientOverlay"></div>
    </div>
    <div class="content" :style="{ background: item.bgColor }">
      <div style="clear: both"></div>
      <div
        class="featureBlock"
        v-for="(block, index) in item.blocks.filter(
          (itm) => itm
          // isStaff
          //   ? !itm.parentOnly || itm.staffOnly == 1
          //   : itm.staffOnly == 0 || itm.parentOnly == 1
        )"
        :style="{ 'border-color': item.borderColor }"
        :key="index"
      >
        <div class="blockContent clearfix">
          <div class="leftImageDiv">
            <img v-if="block.image" :src="block.image" class="leftImage" />
          </div>
          <div class="textDiv">
            <div id="actions" v-if="showEditButtons">
              <el-button
                type="primary"
                size="small"
                @click="edit(block)"
                v-if="block.my_item"
                style="margin-bottom: 8px"
                ><i class="fas fa-pencil"></i> Edit</el-button
              >
              <span class="labelText" v-if="!block.my_item && !block.council_id"
                >Core Feature</span
              >
              <span class="labelText" v-if="!block.my_item && block.council_id"
                >Council Feature</span
              >
              <span
                class="labelText"
                v-if="block.staffOnly == 0 && block.parentOnly == 0"
                >All Users</span
              >
              <span
                class="labelText"
                v-if="block.staffOnly == 1 && block.parentOnly != 1"
                >Staff Only</span
              >
              <span
                class="labelText"
                v-if="block.parentOnly == 1 && block.staffOnly != 1"
                >Parents Only</span
              >
              <!-- <el-tooltip
                class="item"
                effect="dark"
                content="Uneditable"
                placement="bottom"
              >
                <el-button class="disabled" v-if="!block.my_item"
                  ><i class="fas fa-lock"></i
                ></el-button>
              </el-tooltip> -->
            </div>
            <p
              class="mainText"
              v-if="block.text.length > 200 && showBlocks.indexOf(index) === -1"
            >
              {{ block.text.substr(0, 200) }}...
              <span @click="showBlock(index)" class="colorBlue">Expand</span>
            </p>
            <p
              class="mainText"
              v-if="showBlocks.indexOf(index) > -1 || block.text.length < 200"
            >
              {{ block.text }}
            </p>
            <el-button
              v-if="block.buttonRoute"
              type="info"
              size="small"
              style="
                font-weight: bold;
                text-transform: uppercase;
                border-radius: 5px;
              "
              @click="redirect(block.buttonRoute)"
            >
              {{ block.buttonLabel }}
            </el-button>
            <el-button
              v-if="native && block.link"
              @click="openUrl(block.link)"
              plain
              type="info"
              style="
                font-weight: bold;
                border: none !important;
                color: #337ab7;
                font-size: 14px;
                border-bottom: 1px solid #21acf5 !important;
              "
              >{{ block.linkLabel }}</el-button
            >
            <a
              v-if="!native && block.link"
              :href="block.link"
              target="_blank"
              style="text-decoration: underline"
              >{{ block.linkLabel }}</a
            >
          </div>
        </div>
      </div>
      <p v-if="item.modalIntroText" class="modalIntroText">
        {{ item.modalIntroText }}
      </p>
      <div v-if="showEditButtons" style="padding-top: 7px; background: white">
        <el-button
          type="primary"
          style="opacity: 1; margin-bottom: 5px"
          @click="addNew"
          >+ Add travel option</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "travel-feature",
  props: {
    item: Object,
    disabled: Boolean,
    isStaff: Boolean,
    showEditButtons: Boolean,
    native: { type: Boolean, default: false },
  },
  data() {
    return {
      open: false,
      showBlocks: [],
    };
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      this.open = !this.open;
      this.$emit("toggled", this.item.id);
    },
    openAction() {
      this.open = true;
    },
    close() {
      this.open = false;
    },
    redirect(to) {
      this.$notify.info({
        title: "Preview",
        message: "Bottom Links and Buttons only work inside User portal",
      });
    },
    showPoll() {
      this.$emit("action", {
        category: this.item.category,
        action: "show_poll",
        modal_type: this.item.modal_type,
        explanation: this.item.modal_explanation,
      });
    },
    openUrl(url) {
      window.postMessage("native_modal__" + url, "*");
      return;
    },
    showBlock(index) {
      this.showBlocks.push(index);
    },
    edit(block) {
      this.$emit("edit", {
        category: this.item.id,
        section: this.item,
        block: block,
      });
    },
    addNew() {
      this.$emit("edit", {
        category: this.item.id,
        section: this.item,
        block: { category: this.item.category, section_id: this.item.id },
      });
    },
  },
};
</script>
<style scoped>
div.blockwrapper {
  height: auto;
  max-height: 50px;
  overflow: hidden;
  margin-bottom: 10px;
  box-shadow: 0 4px 4px #c3c3c3;
  border-radius: 25px;
  transition: all 0.25s linear;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
}
div.blockwrapper.open {
  height: auto;
  max-height: 1000px;
}
div.content {
  opacity: 0.2;
  margin-top: 0px;
  transition: all 0.3s;
}
div.blockwrapper.open div.content {
  margin-top: -5px;
  opacity: 1;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #e6e6e6;
}
div.featureBlock:not(:last-child) {
  border-bottom: 1px solid #dbdbdb;
}
div.top {
  color: white;
  height: 50px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: bold;
  border-radius: 10px;
  z-index: 99;
  cursor: pointer;
  overflow: hidden;
  /* C3C3C3    4-blur       X-0         Y-4 */
}
div.top .gradientOverlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 0.3) 100%
  );
  z-index: -1;
}
div.top.disabled {
  background: #f0f0f0 !important;
  color: #bebebe;
}
img.chevron {
  transform: rotateZ(90deg);
  transition: all 0.3s ease;
  height: 35px;
  position: absolute;
  right: 10px;
}
img.chevron.active {
  transform: rotateZ(180deg);
}
img.chevron.grey {
  filter: invert(20%);
}
div.top span.parentOnlyLabel {
  width: 60px;
  position: absolute;
  left: 10px;
  font-size: 10px;
}
div.top i {
  position: absolute;
  right: 20px;
  top: 15px;
  font-size: 20px;
  color: white;
}
div.leftImageDiv {
  width: 50px;
  height: 50px;
  margin-right: 15px;
  margin-left: 5px;
  /* float: left; */
  display: inline-block;
  background: white;
  border-radius: 25px;
  box-shadow: 0 0 10px #a5a5a5;
  overflow: hidden;
}
img.leftImage {
  width: 50px;
  height: 50px;
  /* padding: 9px; */
  object-fit: contain;
  vertical-align: top;
  /* border-radius: 25px; */
  border: 0;
  overflow: hidden;
  box-sizing: border-box;
}
div.blockContent {
  padding: 10px;
  padding-bottom: 10px;
  text-align: left;
  color: #4d4d4d;
  /* background: #eeeeee; */
  padding-top: 25px;
}
div.blockContent:hover {
  background: rgba(255, 255, 255, 0.2);
}
.textDiv {
  width: calc(100% - 70px);
  display: inline-block;
  vertical-align: top;
}
p {
  white-space: pre-line;
  padding: 5px;
}
p.mainText {
  padding-top: 0px;
  margin-top: 0px;
  margin-right: 140px;
  font-size: 14px;
}
p.modalIntroText {
  margin-top: 5px;
  margin-bottom: 0px;
  padding: 10px 25px;
}
button {
  background: #21acf5 !important;
  opacity: 0.5;
  border: none;
}
div#actions {
  float: right;
}
div#actions button {
  opacity: 1;
}
span.labelText {
  font-size: 12px;
  font-weight: bold;
  display: block;
}
</style>
